import RestApiModel from "@/api/Model/RestApiModel";

class QuotationList extends RestApiModel {
  static getResourceEndpoint() {
    return '/QuotationList';
  }
}

export default QuotationList;
